import { CommonModule } from '@angular/common';
import { Component, computed, inject } from '@angular/core';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-institutions-page',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './app-institutions-page.component.html',
  styleUrls: ['./app-institutions-page.component.scss']
})
export class InstitutionsPageComponent {
  readonly institutions = [
    { name: 'Momentum Medical Aid', accountNumber: 'MMA-22018', lastSync: 'Today, 09:42', status: 'Verified' },
    { name: 'Takealot', accountNumber: 'TK-90134', lastSync: 'Yesterday, 16:05', status: 'Pending review' },
    { name: 'FNB', accountNumber: 'FNB-12010', lastSync: '20 Apr 2026', status: 'Synced' }
  ];
}

@Component({
  selector: 'app-payment-details-page',
  standalone: true,
  imports: [ReactiveFormsModule],
  templateUrl: './app-payment-details-page.component.html',
  styleUrls: ['./app-payment-details-page.component.scss']
})
export class PaymentDetailsPageComponent {
  private readonly formBuilder = inject(FormBuilder);

  readonly form = this.formBuilder.group({
    cardholderName: ['Jane Dlamini', Validators.required],
    cardNumber: ['4111 1111 1111 1111', Validators.required],
    expiryDate: ['08/29', Validators.required],
    cvv: ['123', Validators.required]
  });

  readonly cardType = computed(() => {
    const value = (this.form.controls.cardNumber.value ?? '').replace(/\s+/g, '');
    if (/^4/.test(value)) {
      return 'Visa';
    }

    if (/^(5[1-5]|2(2[2-9]|[3-6]\d|7[01]|720))/.test(value)) {
      return 'Mastercard';
    }

    if (/^3[47]/.test(value)) {
      return 'Amex';
    }

    return 'Unknown';
  });
}

@Component({
  selector: 'app-billing-page',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, RouterLink],
  templateUrl: './app-billing-page.component.html',
  styleUrls: ['./app-billing-page.component.scss']
})
export class BillingPageComponent {
  private readonly formBuilder = inject(FormBuilder);

  readonly billingForm = this.formBuilder.group({
    cardholderName: ['Jane Dlamini', Validators.required],
    cardNumber: ['5555 5555 5555 4444', Validators.required],
    expiryDate: ['11/28', Validators.required],
    cvv: ['442', Validators.required],
    billingAddress: ['14 Long Street, Observatory, Cape Town, 7925', Validators.required]
  });

  readonly invoices = [
    { reference: 'INV-2026-04', period: 'April 2026 subscription', amount: 'R249.00', status: 'Current' },
    { reference: 'INV-2026-03', period: 'March 2026 subscription', amount: 'R249.00', status: 'Paid' },
    { reference: 'INV-2026-02', period: 'February 2026 subscription', amount: 'R249.00', status: 'Paid' }
  ];

  readonly detectedCardType = computed(() => {
    const digits = (this.billingForm.controls.cardNumber.value ?? '').replace(/\s+/g, '');
    return /^4/.test(digits) ? 'Visa' : /^(5[1-5]|2)/.test(digits) ? 'Mastercard' : 'Unknown';
  });
}

@Component({
  selector: 'app-my-account-page',
  standalone: true,
  imports: [ReactiveFormsModule],
  templateUrl: './app-my-account-page.component.html',
  styleUrls: ['./app-my-account-page.component.scss']
})
export class MyAccountPageComponent {
  private readonly formBuilder = inject(FormBuilder);

  readonly profileForm = this.formBuilder.group({
    fullName: ['Jane Dlamini', Validators.required],
    email: ['jane@example.com', [Validators.required, Validators.email]],
    phoneNumber: ['+27 72 123 4567', Validators.required],
    physicalAddress: ['14 Long Street, Observatory, Cape Town, 7925', Validators.required]
  });

  readonly securityForm = this.formBuilder.group({
    contactPreference: ['email', Validators.required],
    loginEmail: ['jane@example.com', [Validators.required, Validators.email]],
    newPassword: [''],
    otpDelivery: ['sms', Validators.required]
  });
}

@Component({
  selector: 'app-get-help-page',
  standalone: true,
  imports: [ReactiveFormsModule],
  templateUrl: './app-get-help-page.component.html',
  styleUrls: ['./app-get-help-page.component.scss']
})
export class GetHelpPageComponent {
  private readonly formBuilder = inject(FormBuilder);

  readonly supportForm = this.formBuilder.group({
    callbackNumber: ['+27 72 123 4567'],
    whatsAppNumber: ['+27 72 123 4567'],
    supportRequest: ['I need help updating my mobile number across linked institutions.']
  });
}